module.exports = __webpack_public_path__ + "img/profile-tokido.dbad708c.jpg";